import { useEffect, useState } from "react";

/**
 * Debounced copy of a fast-changing value: re-renders with the latest value
 * once it has been stable for `ms`. Feed the result (not the raw input) to
 * anything that hits the network per change — search queries, id lookups —
 * so typing never fans out into a request per keystroke.
 */
export function useDebounced<T>(value: T, ms: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
